(() => {
  'use strict';

  const VERSION = '2026-08-30.2';
  const DEFAULT_CLICK_DELAY = 1200;
  const DEFAULT_ADD_DELAY = 1800;
  const cartUrl = window.theme?.routes?.cart_url || '/cart';
  const cartLinkSelector = '#cart-drawer-toggle, a[href="/cart"], a[href$="/cart"]';
  let fallbackTimer;
  let drawerMonitor;

  const essentialRoot = () => document.querySelector('essential-cart-app-embed');

  const essentialDrawerConfigured = () => {
    const root = essentialRoot();
    if (!root) return false;

    const rawConfig = root.getAttribute('upsell-app-data');
    if (!rawConfig) return true;

    try {
      const config = JSON.parse(rawConfig);
      return (config.carts || []).some(
        (cart) => cart?.isPublished === true && cart?.cartType === 'CART_DRAWER'
      );
    } catch (error) {
      return true;
    }
  };

  window.__dbCartDrawerFallback = {
    version: VERSION,
    essentialDrawerConfigured
  };

  const isVisible = (element) => {
    if (!element || element.getAttribute('aria-hidden') === 'true') return false;
    const style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    const rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const essentialDrawerIsOpen = () => {
    const rootClasses = `${document.documentElement.className} ${document.body.className}`;
    const closedClass = /essential-cart[^\s]*closed/i.test(rootClasses);
    if (closedClass) return false;

    const openClass = /essential-cart[^\s]*(?:open|opened)/i.test(rootClasses) && !closedClass;
    const root = essentialRoot();
    const scopes = [document];
    if (root?.shadowRoot) scopes.push(root.shadowRoot);

    return scopes.some((scope) => {
      const containers = scope.querySelectorAll(
        '#essential-cart-drawer-portal, #cart-drawer.essential-cart-drawer-container, [class*="essential-cart-drawer"]'
      );
      return Array.from(containers).some((container) => {
        if (!isVisible(container)) return false;
        const hasContent = container.children.length > 0 || container.textContent.trim().length > 0;
        return openClass || hasContent;
      });
    });
  };

  const nativeDrawerIsOpen = () => {
    const drawer = document.getElementById('Cart-Drawer');
    return Boolean(drawer?.classList.contains('active') && isVisible(drawer));
  };

  const drawerIsOpen = () => essentialDrawerIsOpen() || nativeDrawerIsOpen();

  const clearFallback = () => {
    window.clearTimeout(fallbackTimer);
    window.clearInterval(drawerMonitor);
    fallbackTimer = undefined;
    drawerMonitor = undefined;
  };

  const goToCartIfNeeded = () => {
    clearFallback();
    if (drawerIsOpen() || window.location.pathname === cartUrl) return;
    window.location.assign(cartUrl);
  };

  const scheduleFallback = (defaultDelay) => {
    clearFallback();
    if (window.location.pathname === cartUrl) return;
    if (essentialDrawerConfigured()) return;

    fallbackTimer = window.setTimeout(goToCartIfNeeded, defaultDelay);
    drawerMonitor = window.setInterval(() => {
      if (drawerIsOpen()) clearFallback();
    }, 100);
  };

  document.addEventListener('cart:item-added', () => scheduleFallback(DEFAULT_ADD_DELAY));
  document.addEventListener('cart-drawer:open', () => scheduleFallback(DEFAULT_CLICK_DELAY));

  window.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const cartLink = event.target.closest?.(cartLinkSelector);
    if (!cartLink || window.location.pathname === cartUrl) return;

    if (essentialDrawerConfigured()) {
      clearFallback();
      return;
    }
    scheduleFallback(DEFAULT_CLICK_DELAY);
  }, true);

  window.addEventListener('pagehide', clearFallback);
})();
